import { render } from "./head.vue?vue&type=template&id=d1c1b77c"
import script from "./head.vue?vue&type=script&lang=js"
export * from "./head.vue?vue&type=script&lang=js"

import "./head.vue?vue&type=style&index=0&id=d1c1b77c&lang=scss"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__